import React, {useState} from 'react'
import Video from '../videos/video.mp4'
import {HeroContainer, HeroBg, VideoBg, HeroContent, HeroH1, HeroP, HeroBtnWrapper, ArrowForward, ArrowRight} from "./HeroElements"
import {Button} from '../ButtonElement';

const HeroSection = () => {
    const[hover, setHover] = useState(false)
    const onHover = () => {
        setHover(!hover)
    }
  return (
    <HeroContainer id="about">
        <HeroBg>
            <VideoBg autoPlay loop muted src={Video} type='video/mp4' />
        </HeroBg>
        <HeroContent>
            <HeroH1>Analisis Eksplorasi Data</HeroH1>
            <HeroP>Mari belajar cara memvisualisasi dan menginterpretasikan data dengan cara yang menyenangkan!</HeroP>
            <HeroBtnWrapper>
                <Button 
                    to="materi" 
                    offset={-150}
                    smooth={true}
                    onMouseEnter={onHover} 
                    onMouseLeave={onHover}
                    primary='true'
                    dark='true'>
                    Learn More {hover ? <ArrowForward/> : <ArrowRight/>}
                </Button>
            </HeroBtnWrapper>
        </HeroContent>
    </HeroContainer>
  )
}

export default HeroSection